export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const setQuery = (queryObj) => ({
  type: SET_SEARCH_QUERY,
  payload: queryObj,
});
